
define('text!modules/core/modules/utils/directives/loaded-list/template-empty.html',[],function () { return '<li class=list:empty>SHARED.LIST.EMPTY</li>';});

